import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "../components/AppLayout";
import { LoginPage } from "../features/auth/LoginPage";
import { OAuthCallbackPage } from "../features/auth/OAuthCallbackPage";
import { PermissionRoute } from "../components/PermissionRoute";
import { OverviewPage } from "../features/overview/OverviewPage";
import { ModelsPage } from "../features/models/ModelsPage";
import { ChannelDetailPage } from "../features/models/ChannelDetailPage";
import { ConsumersPage } from "../features/consumers/ConsumersPage";
import { ConsumerDetailPage } from "../features/consumers/ConsumerDetailPage";
import { ConsumerModelsPage } from "../features/consumers/BusinessDetailPage";
import { CircuitsPage } from "../features/circuits/CircuitsPage";
import { RequestsPage } from "../features/requests/RequestsPage";
import { RequestDetailPage } from "../features/requests/RequestDetailPage";
import { CostsPage } from "../features/costs/CostsPage";
import { ProvidersPage } from "../features/providers/ProvidersPage";
import { PlaygroundPage } from "../features/playground/PlaygroundPage";
import { RuntimePage } from "../features/runtime/RuntimePage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/oauth/callback" element={<OAuthCallbackPage />} />
      <Route element={<AppLayout />}>
        <Route path="/manage/overview" element={<PermissionRoute permission="overview.read"><OverviewPage /></PermissionRoute>} />
        <Route path="/manage/playground" element={<PermissionRoute permission="playground.generate"><PlaygroundPage /></PermissionRoute>} />
        <Route path="/manage/models" element={<PermissionRoute permission="models.read"><ModelsPage /></PermissionRoute>} />
        <Route path="/manage/models/:modelId" element={<Navigate to="/manage/models" replace />} />
        <Route path="/manage/models/:modelId/channels/:channelId" element={<PermissionRoute permission="models.read"><ChannelDetailPage /></PermissionRoute>} />
        <Route path="/manage/providers" element={<PermissionRoute permission="providers.read"><ProvidersPage /></PermissionRoute>} />
        <Route path="/manage/consumers" element={<PermissionRoute permission="consumers.read"><ConsumersPage /></PermissionRoute>} />
        <Route path="/manage/consumers/:consumerId" element={<PermissionRoute permission="consumers.read"><ConsumerDetailPage /></PermissionRoute>} />
        <Route path="/manage/consumers/:consumerId/models" element={<PermissionRoute permission="consumers.read"><ConsumerModelsPage /></PermissionRoute>} />
        <Route path="/manage/circuits" element={<PermissionRoute permission="circuits.read"><CircuitsPage /></PermissionRoute>} />
        <Route path="/manage/runtime" element={<PermissionRoute permission="models.read"><RuntimePage /></PermissionRoute>} />
        <Route path="/manage/requests" element={<PermissionRoute permission="requests.read"><RequestsPage /></PermissionRoute>} />
        <Route path="/manage/requests/:requestId" element={<PermissionRoute permission="requests.read"><RequestDetailPage /></PermissionRoute>} />
        <Route path="/manage/costs" element={<PermissionRoute permission="costs.read"><CostsPage /></PermissionRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/manage/overview" replace />} />
    </Routes>
  );
}
